import React, { useEffect, useState, useCallback } from "react";
import styles from "./HeroSection.module.css";
import { motion } from "framer-motion";
import NavGuard from "./NavGuard";
import { smoothScrollTo } from "../utils/smoothScroll";

const posterSet = {
  avif: "/media/video-light/posters/hero1.avif",
  webp: "/media/video-light/posters/hero1.webp",
  jpg: "/media/video-light/posters/hero1.jpg",
};

export default function HeroSection() {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" &&
      window.matchMedia("(max-width:820px)").matches
  );
  const [scrollGone, setScrollGone] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const mqMob = window.matchMedia("(max-width:820px)");
    const onChange = () => setIsMobile(mqMob.matches);
    mqMob.addEventListener?.("change", onChange);

    return () => mqMob.removeEventListener?.("change", onChange);
  }, []);

const handleScrollClick = useCallback(() => {
  const target =
    document.querySelector('[data-section="about"]') ||
    document.querySelector("#about");

  if (!target) return;

  const rect = target.getBoundingClientRect();

  const rootStyles = getComputedStyle(document.documentElement);
  const navH = parseFloat(rootStyles.getPropertyValue("--nav-h") || "0");
  const under = parseFloat(
    rootStyles.getPropertyValue("--nav-underline-h") || "0"
  );

  const y =
    window.scrollY +
    rect.top -
    (navH + under) +
    40;

  smoothScrollTo(y, 650);
}, []);


  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 16) setScrollGone(true);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const objectPosition = isMobile ? "50% 38%" : "50% 50%";

  const videoSrc = isMobile
    ? "/media/video-light/mp4/720/hero-720.mp4"
    : "/media/video-light/mp4/1080/hero-1080.mp4";

  return (
    <section className={`${styles.hero} ${isMobile ? styles.mobile : ""}`}>
      <NavGuard />

      {/* Постер */}
      <picture className={styles.heroPoster}>
        <source srcSet={posterSet.avif} type="image/avif" />
        <source srcSet={posterSet.webp} type="image/webp" />
        <img
          src={posterSet.jpg}
          alt=""
          width={1920}
          height={1080}
          decoding="async"
          loading="eager"
          className={styles.poster}
        />
      </picture>

      <video
        className={`${styles.video} ${styles.show}`}
        style={{ objectPosition }}
        autoPlay
        muted
        playsInline
        loop
        preload="auto"
        disableRemotePlayback
      >
        <source src={videoSrc} type="video/mp4" />
      </video>

      <div className={styles.overlay} />
{isMobile && (
  <div className={styles.mobileBrand}>
    <h1>Dr. Fernando International GmbH</h1>
  </div>
)}
      <motion.div
        className={styles.content}
        initial={false}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: "easeOut" }}
      >

      </motion.div>

      <div
        className={`${styles.scrollCue} ${
          scrollGone ? styles.scrollCueHide : ""
        }`}
      >
        <button
          type="button"
          className={styles.scrollArch}
          onClick={handleScrollClick}
        >
          <span className={styles.scrollLabel}>Hier klicken</span>
          <span className={styles.scrollArchLine} />
          <span className={styles.scrollArchStem} />
        </button>
      </div>
    </section>
  );
}
